import { styled } from "@mui/material/styles";
import { TextField } from "@mui/material";
import colors from "../../utils/colors";

export const GreenTextField = styled(TextField)(({ theme, error }) => ({
  "& input.MuiOutlinedInput-input": {
    paddingLeft: "16px",
    paddingRight: "16px",
    paddingTop: "8px",
    paddingBottom: "8px",
    fontSize: 14,
    lineHeight: "14px",
    color: colors.neutral[1000],
  },
  "& textarea.MuiOutlinedInput-input": {
    paddingLeft: "16px",
    paddingRight: "16px",
    paddingTop: "8px",
    paddingBottom: "8px",
    fontSize: 14,
    lineHeight: "20px",
    color: colors.neutral[1000],
  },
  "& .MuiInputLabel-root + .MuiInputBase-root input.MuiOutlinedInput-input": {
    paddingTop: "22px",
    paddingBottom: "6px",
  },
  "& .MuiInputLabel-root + .MuiInputBase-root textarea.MuiOutlinedInput-input": {
    paddingTop: "22px",
    paddingBottom: "8px",
  },
  "& .MuiInputLabel-root + .MuiInputBase-root.MuiInputBase-sizeSmall textarea.MuiOutlinedInput-input": {
    paddingTop: "18px",
  },
  "& .MuiInputLabel-root":  { fontSize: 14, lineHeight: "14px", color: colors.neutral[800], paddingBottom: "4px" },
  "& .MuiInputLabel-root.Mui-focused": { color: colors.neutral[800] },
  "& .MuiInputLabel-shrink": {
    backgroundColor: "transparent!important",
    marginTop: "14px",
    color: colors.neutral[800],
    paddingTop: "0px!important",
    paddingLeft: "11px!important",
  },
  "& .MuiInputBase-multiline .MuiInputLabel-shrink": {
    marginTop: "0px",
    paddingLeft: "8px!important",
  },
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px",
    backgroundColor: "white",
    borderColor: error ? colors.red[500] : colors.neutral[300],
    "& fieldset": {
      borderColor: error ? colors.red[500] : colors.neutral[300],
    },
  },
  "& .MuiOutlinedInput-root.MuiInputBase-multiline": {
    padding: 0,
  },
  "& .MuiOutlinedInput-root.Mui-focused": {
    borderColor: error ? colors.red[500] : colors.primary[300],
    "& fieldset": {
      borderColor: error ? colors.red[500] : colors.primary[300],
    },
  },
  "& .MuiOutlinedInput-root.Mui-error": {
    "& fieldset": {
      borderColor: colors.red[500],
    },
  },
  "& .MuiFormHelperText-root.Mui-error": {
    color: colors.red[500],
    fontSize: 12,
  },
}));
